/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit'
import * as Services from '../../services/endpoints'
import { IPAScript, IPAScriptBody } from '../../types'
import { createGenericSlice, GenericState } from '../lib'

const sliceName = 'scripts'

//todo Should rename to something like ipa script to avoid conflicts
//todo need to reverse this and use the sate as the type
export interface ScriptState extends GenericState<IPAScript> {}

const scriptsAdapter = createEntityAdapter()

export const initialScriptsState: ScriptState = {
  ids: [],
  entities: {},
  loading: false,
  error: null
}

export const getAllScript = createAsyncThunk(
  `${sliceName}/getAllScript`,
  async (_, { rejectWithValue }) => {
    try {
      return await Services.getAllScript()
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const getScript = createAsyncThunk(
  `${sliceName}/getScript`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.getScript(id)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const createScript = createAsyncThunk(
  `${sliceName}/createScript`,
  async (body: any, { rejectWithValue }) => {
    try {
      return await Services.createScript(body as IPAScriptBody)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

export const removeScript = createAsyncThunk(
  `${sliceName}/removeScript`,
  async (id: string, { rejectWithValue }) => {
    try {
      return await Services.removeScript(id)
    } catch (err: any) {
      return rejectWithValue(err)
    }
  }
)

const thunkAdapters: any = [
  {
    adapterFn: scriptsAdapter.setAll,
    thunk: getAllScript
  },
  {
    adapterFn: (state, action) => {
      scriptsAdapter.setAll(state, [action])
    },
    thunk: getScript
  },
  {
    adapterFn: scriptsAdapter.addOne,
    thunk: createScript
  },
  {
    adapterFn: scriptsAdapter.removeOne,
    thunk: removeScript
  }
]
export const scriptsSlice = createGenericSlice({
  name: sliceName,
  initialState: initialScriptsState,
  thunkAdapters
})
